import { useState, useEffect } from 'react';

export const useOrderCount = () => {
  const [orderCount, setOrderCount] = useState(0);

  useEffect(() => {
    const updateOrderCount = () => {
      try {
        const orders = JSON.parse(localStorage.getItem('clientOrders') || '[]');
        setOrderCount(orders.length);
      } catch (error) {
        console.error('Error reading orders from localStorage:', error);
        setOrderCount(0);
      }
    };

    // Mettre à jour au chargement
    updateOrderCount();

    // Écouter les changements dans localStorage
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'clientOrders') {
        updateOrderCount();
      }
    };

    // Écouter les changements personnalisés (pour les mises à jour dans la même page)
    const handleCustomOrderUpdate = () => {
      updateOrderCount();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('orderUpdated', handleCustomOrderUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('orderUpdated', handleCustomOrderUpdate);
    };
  }, []);

  return orderCount;
};

// Fonction utilitaire pour déclencher la mise à jour du compteur
export const triggerOrderCountUpdate = () => {
  window.dispatchEvent(new CustomEvent('orderUpdated'));
};